/**
 * FluxLab 应用根组件
 * 组合布局组件和路由配置，渲染整个应用界面
 */
import { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './app/layout';
import { appRoutes } from './app/routes';
import { useWebSocketConnection } from './hooks/use-websocket';

/** 应用根组件：建立全局 WebSocket 连接并渲染布局与路由 */
export default function App() {
  useWebSocketConnection();

  return (
    <Layout>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          {appRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Routes>
      </Suspense>
    </Layout>
  );
}

function RouteFallback() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center" role="status" aria-live="polite">
      <span className="h-6 w-6 animate-spin rounded-full border-2 border-surface-700 border-t-accent-400" />
      <span className="sr-only">正在加载</span>
    </div>
  );
}
